import React from 'react';
import PropTypes from 'prop-types';
import { ICONS } from 'constants/icons';
import { Icon } from 'components/atoms';
import { IconUndo } from '@spotify-internal/encore-web/core';
import * as Styled from './Button.styled';

/**
 * Button component
 * @param {String} type Button type
 * @param {Function} onClick on click handler function
 * @param {String} className Class to override current styles
 * @param {String} text text to place into tag buttons
 */
const Button = ({
  type = 'roundClose',
  onClick = () => {},
  className = '',
  text,
}) => {
  switch (type) {
    case 'roundClose':
      return (
        <Styled.RoundClose onClick={onClick} className={className}>
          <Icon name={ICONS.CLOSE_MARK} />
        </Styled.RoundClose>
      );
    case 'roundLeftArrow':
      return (
        <Styled.RoundArrow onClick={onClick}>
          <Icon name={ICONS.ARROW_LEFT_NO_CONTAINER} />
        </Styled.RoundArrow>
      );
    case 'roundRightArrow':
      return (
        <Styled.RoundArrow onClick={onClick} className={className}>
          <Icon name={ICONS.ARROW_RIGHT_NO_CONTAINER} />
        </Styled.RoundArrow>
      );
    case 'roundUndoArrow':
      return (
        <Styled.RoundArrow onClick={onClick} className={className}>
          <IconUndo />
        </Styled.RoundArrow>
      );
    case 'filter':
      return (
        <Styled.FilterButton onClick={onClick}>
          {text}
          <Icon name={ICONS.FILTER} />
        </Styled.FilterButton>
      );
    case 'filterName':
      return (
        <Styled.FilterButton onClick={onClick}>
          {text}
          <Icon name={ICONS.CLOSE_MARK} />
        </Styled.FilterButton>
      );
    case 'secondary':
      return (
        <Styled.SecondaryButton onClick={onClick} className={className}>
          {text}
        </Styled.SecondaryButton>
      );
    case 'culture-next':
      return (
        <Styled.CultureNextButton onClick={onClick} className={className}>
          {text}
        </Styled.CultureNextButton>
      );
    case 'text':
      return (
        <Styled.TertiaryButton onClick={onClick} className={className}>
          {text}
        </Styled.TertiaryButton>
      );
    default:
      return null;
  }
};

Button.propTypes = {
  /**
   * Button type
   */
  type: PropTypes.string.isRequired,
  /**
   * OnClick Handler
   */
  onClick: PropTypes.func,
  /**
   * Class to override current styles
   */
  className: PropTypes.string,
};

export default Button;
